// Description: Opening / ローディングなし・BG動画再生・オープニングあり・オープニング終了後にFV以下を遅延読み込み

//import Player from '@vimeo/player';
//https://www.npmjs.com/package/@vimeo/player

// import ModalVideo from "modal-video";
// //https://www.npmjs.com/package/modal-video

import { Env } from "./env.js";
import { Urlparam } from "./urlparam.js"; // URLパラメータ
// import { flipManager } from "./mask-flipanim-manager.js";

export class Opening {
  constructor(callback) {
    this.body = {};
    this.html = {};
    this.env = {};
    this.paramAncher = {};
    this.scrolledFlg = false; //indexページではスクロールを一度でもしたらFV以下を読み込み

    // loading
    this.loadingStartTime = 0;
    this.minLoadingTime = 2000;
    this.loadingWaitTime = 0;
    this.loadedFlg = false;

    // console.log(func);
    this.callback = callback;

    //window size
    this.windowWidth = 0;
    this.windowHeight = 0;
    this.nowWidth = 0;
    this.nowHeight = 0;

    //video
    this.bgVideo = document.createElement("video");
    this.coverVimeoId = "";
    this.coverVimeoPc = "https://player.vimeo.com/progressive_redirect/playback/1056642178/rendition/1440p/file.mp4?loc=external&log_user=0&signature=385b59fb71bd65285bd21c13b0f2b9324d049bebeb0234b1f17ab0fddb4e96b3&user_id=53688888";
    this.coverVimeoTab = "https://player.vimeo.com/progressive_redirect/playback/1058837972/rendition/1440p/file.mp4?loc=external&log_user=0&signature=89a42c25207aa6755f991147d641f18f3fe833ae671374faf42b1f0eea4685d3&user_id=53688888";
    this.coverVimeoSp = "https://player.vimeo.com/progressive_redirect/playback/1056671011/rendition/1080p/file.mp4?loc=external&log_user=0&signature=d3610cec1c61e4ae69d4dce357165de4f6b47ba8dc0a1b817bf1cf37535e061b&user_id=53688888";
  }

  // ------------------------------------------------------------
  // 各機能

  //リサイズ判定（ツールバーの変化を除いてウインドウサイズが変わった場合のみ実行）
  isResized() {
    this.body = document.getElementsByTagName("body")[0];

    let resizeFlg = false;
    if (this.body.classList.contains("os-ios") || this.body.classList.contains("os-android")) {
      //モバイルは幅のみで判定、高さはスクロール時にURLバーの大きさが変わる
      if (this.windowWidth !== this.nowWidth) {
        resizeFlg = true;
        // console.log("window size changed mobile");
      }
    } else {
      //PC高さも
      if (this.windowWidth !== this.nowWidth || this.windowHeight !== this.nowHeight) {
        resizeFlg = true;
        //console.log("window size changed PC");
      }
    }
    return resizeFlg;
  }

  // 再生動画のIDを確定: changeBgMovより実行
  getMovId() {
    //画面の縦横比をチェック、再生する動画のIDを返す
    this.windowWidth = document.documentElement.clientWidth;
    this.windowHeight = document.documentElement.clientHeight;
    //this.windowInnerWidth = window.innerWidth; //ツールバーを除く
    //this.windowInnerHeight = window.innerHeight; //ツールバーを除く
    let windowRatio = this.windowWidth / this.windowHeight;
    let coverVimeoId;
    if (windowRatio >= 9 / 8) {
      coverVimeoId = this.coverVimeoPc;
    } else if (windowRatio >= 9 / 14) {
      coverVimeoId = this.coverVimeoTab;
    } else {
      coverVimeoId = this.coverVimeoSp;
    }
    //console.log("detect: Now VimeoId " + coverVimeoId + ", ratio = " + returnStr);
    return coverVimeoId;
  }

  // 動画の初期化: initより実行
  initBgMovFile() {
    //index firstview BG(vimeo ファイル直リンク版) #video要素にて
    this.nextVimeoId = this.getMovId();

    //videoタグを作成し、#videoに設置して読み込み開始
    this.bgVideo.id = "bg-mov";
    this.bgVideo.src = this.nextVimeoId;
    this.bgVideo.autoplay = false; //true;
    this.bgVideo.muted = true;
    this.bgVideo.loop = false; //true;
    this.bgVideo.controls = false;
    this.bgVideo.playsInline = true;
    this.bgVideo.preload = "auto";
    document.getElementById("video").appendChild(this.bgVideo);

    this.bgVideo.addEventListener("canplay", () => {
      if (!this.loadedFlg) {
        console.log("opening loaded");
        this.startOpening();
        this.loadedFlg = true;
      }
    });

    this.bgVideo.addEventListener("timeupdate", () => {
      //console.log(this.bgVideo.currentTime);
      if (this.bgVideo.currentTime >= 3.833) {
        //frame数*1/30*1000で計算
        this.bgVideo.currentTime = 1.2;
      }
    });

    this.bgVideo.load(); //iOSで必要
  }

  // 動画の切り替えを実行
  changeBgMov() {
    console.log("change mov");
    if (this.nextVimeoId !== this.getMovId()) {
      this.nextVimeoId = this.getMovId();
      this.bgVideo.src = this.nextVimeoId;
      this.bgVideo.play();
    }
  }

  //FV以下のコンテンツ表示: afterOpより実行
  showMainContent() {
    let template;
    let clone;
    // HomeのOP以下のコンテンツ
    if (document.getElementById("index-content-template")) {
      template = document.getElementById("index-content-template");
      clone = template.content.cloneNode(true);
      document.getElementById("js-index-content-container").appendChild(clone);
    }
  }

  // ------------------------------------------------------------
  // 01. 初期化
  init() {
    this.body = document.getElementsByTagName("body")[0];
    this.html = document.getElementsByTagName("html")[0];
    this.env = new Env();
    this.env.detectEnv();
    this.paramAncher = new Urlparam();
    this.paramAncher.getParam("op", location.href);

    // OP実行判定
    if (document.getElementById("index-cover")) {
      // bg mov読み込み開始
      this.initBgMovFile(); //ファイル直リンク版

      if (this.paramAncher.param == 0) {
        // Openingスキップ
        window.setTimeout(() => {
          this.body.classList.add("op-finished");
          this.afterOp();

          //FirstView
          let fvElem = document.querySelector(".common-cover__first");
          if (fvElem) {
            fvElem.classList.add("inview");
          }
        }, 300);
        window.setTimeout(() => {
          this.body.classList.add("op-finished2");
          document.getElementById("index-bg").classList.add("inview");
        }, 1200);
      }
    } else {
      //OP要素がない
      this.startOpening();
    }
  }

  // ------------------------------------------------------------
  // 02. Opening開始
  startOpening() {
    window.setTimeout(() => {
      this.body.classList.add("op-start"); //logo
      console.log("op-start");
    }, 50);

    window.setTimeout(() => {
      if (document.getElementById("index-bg")) {
        document.getElementById("index-bg").classList.add("inview"); //bg
      }
      this.bgVideo.play();
    }, 600);

    window.setTimeout(() => {
      this.body.classList.add("op-finished"); //lead
    }, 1000);

    window.setTimeout(() => {
      this.body.classList.add("show-menu");
    }, 1200);

    let tt = 1300;
    if (document.getElementById("index-cover")) {
      tt = 2500;
    }

    window.setTimeout(() => {
      this.body.classList.add("op-finished2");
      this.afterOp();
    }, tt);
  }

  // ------------------------------------------------------------
  // 03. オープニング終了後の処理
  afterOp() {
    //FV以下のコンテンツ
    this.showMainContent();

    //Mainへcallback
    this.callback();
  }

  // ------------------------------------------------------------
  // リサイズ時
  onResize() {
    this.nowWidth = window.innerWidth;
    this.nowHeight = window.innerHeight;

    let windowSizeChanged = this.isResized();
    if (windowSizeChanged) {
      this.changeBgMov();
      console.log("opening: onResize=true, initBgMovFile()");
    }
  }

  // ------------------------------------------------------------
  // スクロール時
  onScroll() {
    // nothing
  }
}
